import { type Alignment, type AlignItems, type JustifyContent } from "../types/common.types";

export const FlexColumnAlignment: Record<Alignment, { items: AlignItems; content: JustifyContent }> = {
	"top-left": {
		items: "flex-start",
		content: "flex-start",
	},
	"top-center": {
		items: "center",
		content: "flex-start",
	},
	"top-right": {
		items: "flex-end",
		content: "flex-start",
	},
	"center-left": {
		items: "flex-start",
		content: "center",
	},
	center: {
		items: "center",
		content: "center",
	},
	"center-right": {
		items: "flex-end",
		content: "center",
	},
	"bottom-left": {
		items: "flex-start",
		content: "flex-end",
	},
	"bottom-center": {
		items: "center",
		content: "flex-end",
	},
	"bottom-right": {
		items: "flex-end",
		content: "flex-end",
	},
};

export const FlexRowAlignment: Record<Alignment, { items: AlignItems; content: JustifyContent }> = {
	"top-left": {
		items: "flex-start",
		content: "flex-start",
	},
	"top-center": {
		items: "flex-start",
		content: "center",
	},
	"top-right": {
		items: "flex-start",
		content: "flex-end",
	},
	"center-left": {
		items: "center",
		content: "flex-start",
	},
	center: {
		items: "center",
		content: "center",
	},
	"center-right": {
		items: "center",
		content: "flex-end",
	},
	"bottom-left": {
		items: "flex-end",
		content: "flex-start",
	},
	"bottom-center": {
		items: "flex-end",
		content: "center",
	},
	"bottom-right": {
		items: "flex-end",
		content: "flex-end",
	},
};
